import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ProjectAbout = ({ about, name }) => {
  if (!about?.length) return null;

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.title}>{name} Hakkında</h2>
      <div className={styles.about} dangerouslySetInnerHTML={{ __html: about }} />
    </section>
  );
};

ProjectAbout.propTypes = {
  about: PropTypes.string,
  name: PropTypes.string,
};

export default ProjectAbout;
